// extracted by mini-css-extract-plugin
export default {"recipeContainer":"Recipes_recipeContainer__NwHJE"};